import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { QuizAnnotationPosition, QuizRowConfig } from '~/landingV4/types/quiz.types'

const annotationPositionClasses: Record<QuizAnnotationPosition, string> = {
  'top-left': 'top-10 -left-20',
  'bottom-left': 'bottom-5 -left-24',
  'bottom-right': 'bottom-10 right-8',
}

interface Props {
  config: QuizRowConfig
  imageSrc: string
}

export default function QuizRow({ config, imageSrc }: Props): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const { annotations, imageRight, mobileImageTop, resultKey, stepNumber, titleKey } = config

  const directionClass = `${mobileImageTop ? 'flex-col' : 'flex-col-reverse'} ${
    imageRight ? 'md:flex-row-reverse' : 'md:flex-row'
  }`

  return (
    <div className={`flex items-center gap-8 md:gap-16 ${directionClass}`}>
      <div className="relative w-full shrink-0 md:w-165">
        <ResponsiveImage
          alt={t(titleKey)}
          className="block w-full overflow-hidden rounded-4 shadow-card"
          imageClassName="w-full rounded-4"
          srcKey={imageSrc}
        />
        {annotations.map(({ position, textKey }) => (
          <span
            className={`absolute hidden rounded-full bg-purple-nebula min-w-48 px-4 py-2.5 text-sm text-center font-medium text-white shadow-large md:block ${annotationPositionClasses[position]}`}
            key={textKey}
          >
            {t(textKey)}
          </span>
        ))}
      </div>
      <div className="flex w-full flex-col gap-4 md:max-w-115">
        <span className="flex h-13 w-13 items-center justify-center rounded-full bg-lime-200 text-lg font-bold text-purple-darker">
          {stepNumber}
        </span>
        <h3 className="text-lg font-bold leading-tight text-purple-darker md:text-h3">{t(titleKey)}</h3>
        <p className="text-md leading-relaxed text-purple-darker">
          <Trans
            components={{ hand: <span className="font-hand text-[26px] text-purple" /> }}
            i18nKey={resultKey}
            t={t}
          />
        </p>
      </div>
    </div>
  )
}
